import React, { useCallback, useState } from "react";
import { ReactComponent as BarsIcon } from '../assets/pic/bars-solid.svg';
import LanguageSelector from '../languages/LanguageSelector';
import "../style/styles.css";
import "../style/cart.css";
import Order from "../shop/Order";
import Bill from "../shop/Bill";
import { Text } from '../languages/Language';
import UserProfile from "./UserProfile";
import LoginModal from "../shop/LoginModal";
import RegisterModal from "../shop/RegisterModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBasketShopping, faClose, faHome, faSearch, } from '@fortawesome/free-solid-svg-icons';
import { debounce } from "lodash";
import { MENU_LOGO_BACKGROUND, MENU_WHITE_BACKGROUND } from "../constants";
import { CONFIG } from "../config";

export default function MenuHome(props) {
  const [menuOpen, setMenuOpen] = React.useState(false);
  const [term, setTerm] = useState('');
  const [cartQuantity, setCartQuantity] = useState(0);
  const [showRegisterModal, setShowRegisterModal] = useState(false);
  const logo = require(`../../vendors/${CONFIG.PROJECTNAME}/app_logo_appbar.png`);

  const handleShowRegisterModal = (value) => {
    setShowRegisterModal(value);
  };

  const addToCart = () => {
    setCartQuantity(cartQuantity + 1);
  };


  const debouncedSearch = useCallback(
    debounce((searchTerm) => {
      if (searchTerm.length > 1) {
        props.search(searchTerm);
      }
    }, 1000),
    []
  );

  const handleInputChange = (event) => {
    const value = event.target.value;
    setTerm(value);
    debouncedSearch(value);
    if (value == "") {
      handleOpen();
    }
  };

  const handleSearch = () => {
    props.search(term);
  };

  const clickHandler = () => {
    setMenuOpen(!menuOpen)
    props.search("");
    setTerm("")
    //setMenuOpen(!menuOpen)
  }

  const parentHandleToken = (isLogged) => {

    props.setAppToken(isLogged);
  };

  const handleOpen = () => {
    props.WebCategory("Home", null)
  };

  return (
    <>
      <div
        className={`font-normal w-full flex flex-row ${MENU_WHITE_BACKGROUND ? "text-menu-secondary-color bg-white" : "text-white bg-menu-secondary-color"}`}
      >
        <nav
          className=" w-full  lg:px-3 border-b-2 items-center justify-between flex flex-row"
        >

          <div
            className="px-4 md:hidden flex-row  justify-start flex"
          >
            <button
              className="lg:hidden cursor-pointer text-xl leading-none p-1
                border border-solid border-transparent rounded-lg bg-transparent
                outline-none focus:outline-none"
              type="button"
              onClick={props.toggleMenu}
            >
              <BarsIcon
                className={`px-2 w-10 ${MENU_WHITE_BACKGROUND ? "fill-menu-secondary-color" : "fill-white"}`}
              />
            </button>
            <button
              className="cursor-pointer text-xl leading-none border border-solid
                  border-transparent rounded-lg bg-transparent outline-none focus:outline-none"
              type="button"
              onClick={props.onClick}
            >
            </button>
          </div>

          <div className={`${menuOpen ? "hidden" : "grid flex-none items-center content-center "}`}
          >
            <img className={`flex content-center items-center justify-center h-12 p-1 ${MENU_LOGO_BACKGROUND ? "bg-white p-1 rounded-sm" : ""}`}
              src={logo} alt="Logo" />
          </div>
          <button
            title="Home"
            onClick={handleOpen}
            className={`hidden md:flex m-1 items-center
              justify-center  p-4 ml-auto
              text-sm font-bold hover:opacity-75 ${MENU_WHITE_BACKGROUND ? "text-menu-secondary-color" : "text-white"}`}
            href="#pablo"
          >
            <FontAwesomeIcon className=" h-5" icon={faHome} />
            <div className="pl-2 hidden lg:block text-sm"><Text tid="Home" /></div>
          </button>

          <div className="flex mr-auto">
            { /*desktop search */}
            {sessionStorage.getItem("token")
              ?
              <>


                <div
                  className="hidden md:flex items-center w-full "
                >
                  <div className="flex flex-row items-center gap-x-1 border-menu-secondary-color border pl-2 rounded-[4px]">
                    <div>
                      <FontAwesomeIcon icon={faSearch} />
                    </div>
                    <div>
                      <input
                        value={term}
                        type="search"
                        onChange={(event) => { handleInputChange(event) }}
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.code === "Enter") {
                            // handleSearch();
                          }
                        }}
                        className="appearance-none form-control  flex w-[30vw]  h-10
                  text-base font-normal text-slate-700
                 border-2 border-white transition ease-in-out rounded-sm
                   m-0 focus:text-slate-700 focus:bg-white  focus:ring-0 focus:border-white
                   focus:outline-none"
                        aria-label="Search"
                        aria-describedby="button-addon3"
                      />
                    </div>

                  </div>


                </div>
              </>

              : <div></div>
            }
          </div>

          <div
            className="flex font-bold flex-row px-5 py-1 justify-end "
          >



            <ul
              className="items-center xl:space-x-2 flex justify-end flex-row  xl:w-1/3
             lg:flex-row list-none"
            >

              { /*bill order */}
              {sessionStorage.getItem("token")
                ? <>
                  <li
                    className="nav-item hidden md:flex"
                  >
                    <Order onWait={props.onWait} onLoadSavedSlip={() => props.onLoadSavedSlip()} />
                  </li>
                  <li
                    className="nav-item hidden md:flex"
                  >
                    <Bill />
                  </li>   </>
                : null
              }

              { /*login register language */}
              {!sessionStorage.getItem("token")
                ? <>
                  <li>
                    <RegisterModal showModal={showRegisterModal} setShowModal={handleShowRegisterModal}></RegisterModal>
                  </li>

                  <li
                    className="nav-item"
                  >
                    <LoginModal

                      parentHandleToken={parentHandleToken}
                      onGetItems={() => props.onGetItems()}
                      onGetCategories={() => props.onGetCategories()}
                      setShowRegisterModal={handleShowRegisterModal}
                    />
                  </li>
                  <li>
                    <LanguageSelector menu="true" />
                  </li>
                </>
                : null
              }

              { /*mobile search input */}
              <div
                className={`${menuOpen ? "block md:hidden justify-center flex-row items-center border border-menu-secondary-color " : "hidden"}`}
              >

                <input
                  value={term}
                  onChange={(event) => { handleInputChange(event) }}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.code === "Enter") {
                      handleSearch();
                    }
                  }}
                  type="search"
                  className=" appearance-none form-control relative flex   px-1 h-10
                      py-1.5 text-base font-normal text-slate-700 bg-white bg-clip-padding
                       border-white transition ease-in-out rounded-sm
                      m-0 focus:text-slate-700 focus:bg-white  focus:ring-0 focus:border-white
                      focus:outline-none"
                  placeholder=""
                  aria-label="Search"
                  aria-describedby="button-addon3"
                />

              </div>

              { /*mobile search button */}
              <button
                className={`flex md:hidden appearance-none px-4 py-2
                      font-medium text-xs leading-tight
                      hover:outline-none focus:outline-none focus:ring-0 focus:ring-transparent transition
                      items-center justify-end
                      duration-150 ease-in-out ${MENU_WHITE_BACKGROUND ? "text-menu-secondary-color" : "text-white"}`}
                type="button"
                id="button-addon3"
                onClick={clickHandler}
              >
                {menuOpen ?
                  <FontAwesomeIcon className={`w-6 h-6 ${MENU_WHITE_BACKGROUND ? "fill-menu-secondary-color" : "fill-white"}`} icon={faClose} /> :
                  <FontAwesomeIcon icon={faSearch} className={`w-6 h-6  ${MENU_WHITE_BACKGROUND ? "fill-menu-secondary-color text-menu-secondary-color" : "fill-white text-white"}`} />}
              </button>

              { /* cart */}
              <div onClick={props.toggleCart}
                className={`${menuOpen ?
                  "hidden" :
                  "relative self-center cursor-pointer text-xxs lg:text-sm"
                  } ${MENU_WHITE_BACKGROUND ? "text-menu-secondary-color" : "text-white"} `}>

                <div className='flex flex-row h-4 items-center relative hover:opacity-75 px-1 ml-0 sm:ml-1 '>
                  <FontAwesomeIcon icon={faBasketShopping} className={`h-6 w-6  ${MENU_WHITE_BACKGROUND ? "fill-menu-secondary-color stroke-menu-secondary-color" : "fill-white stroke-white"}`} />
                  {props.cartCount > 0 && (
                    <span className="cart-badge">{props.cartCount}</span>
                  )}
                  <div className="text-smfont-bold pl-1.5 hidden lg:block"><Text tid="ShoppingCart"></Text></div>
                </div>
              </div>




              {sessionStorage.getItem('user') && !menuOpen
                ?
                <li>
                  <UserProfile
                    ShowImpressum={(value) => props.ShowImpressum(value)}
                    ShowDatenschutz={(value) => props.ShowDatenschutz(value)}
                    ShowAGB={(value) => props.ShowAGB(value)}
                    ShowContact={(value) => props.ShowContact(value)}
                    ShowAboutUs={(value) => props.ShowAboutUs(value)}
                    handleOpen={handleOpen}
                    setAppToken={props.setAppToken}
                    onLogoutDeleteItemsAndCategories={() => props.onLogoutDeleteItemsAndCategories()} />
                </li>
                : null
              }

            </ul>
          </div>
        </nav>
      </div>
    </>
  );
}